import VerifyExistsEnum from '@constants/VerifyExistsEnum'

const company = state => state.onboarding.companyStep.company
const companyExits = state => state.onboarding.companyStep.cnpjExists.type !== VerifyExistsEnum.EmpresaNaoCadastrada
const categoryList = state => state.onboarding.companyStep.categoryList
const companyRegulation = state => state.onboarding.companyStep.regulation

const legalResponsible = state => state.onboarding.legalResponsibleStep
const address = state => state.onboarding.addressStep.address
const security = state => state.onboarding.securityStep

const onboardingCreateResponse = state => state.onboarding.root.companyId

export { company, companyRegulation, legalResponsible, address, security, onboardingCreateResponse, companyExits, categoryList }
